// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { Capacitor } from '@capacitor/core';
import { PushNotifications } from '@capacitor/push-notifications';
import { FCM } from '@capacitor-community/fcm';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCQ4qWfD9ILAMAC8aV39eMgyermvpMmBVs",
  authDomain: "flujo-app-notificaciones.firebaseapp.com",
  projectId: "flujo-app-notificaciones",
  storageBucket: "flujo-app-notificaciones.firebasestorage.app",
  messagingSenderId: "477157432231",
  appId: "1:477157432231:web:c1cf633cb3d33d7345b482"
};

// Initialize Firebase (Solo para Web, en Nativo se usa google-services.json)
const app = initializeApp(firebaseConfig);
const messaging = Capacitor.isNativePlatform() ? null : getMessaging(app);

// CONFIGURACIÓN MAESTRA PUSH
if (Capacitor.isNativePlatform()) {
  try {
    // ESTO ES LO QUE BUSCAMOS: Forzar banner y sonido en primer plano
    PushNotifications.createChannel({
      id: 'fcm_default_channel',
      name: 'Default',
      description: 'Canal por defecto para despachos',
      importance: 5, // Importancia Máxima
      visibility: 1
    });

    PushNotifications.createChannel({
      id: 'emi_despachos_v2',
      name: 'Despachos EmiGo',
      description: 'Alertas de despachos de alta prioridad',
      importance: 5, // Importancia Máxima
      visibility: 1
    });

    PushNotifications.setPresentationOptions({
      presentationOptions: ['badge', 'sound', 'alert'],
    });
  } catch (error) {
    console.error("⚠️ [PUSH INIT ERROR] Error al crear canales o configurar opciones de notificación:", error);
  }
}

export const requestForToken = async () => {
  if (Capacitor.isNativePlatform()) {
    return new Promise((resolve) => {
      console.log("📱 [LOG] Iniciando registro Push con FCM Plugin...");
      
      try {
        const timeout = setTimeout(() => {
          console.warn("⏱️ [LOG] TIMEOUT: El registro Push tardó más de 10 segundos.");
          resolve(null);
        }, 10000);

        PushNotifications.removeAllListeners();

        PushNotifications.addListener('registration', async (token) => {
          console.log("🔥 [LOG] Registro APNs exitoso. Solicitando token FCM...");
          try {
            const fcm = await FCM.getToken();
            console.log("🔥 [LOG] TOKEN FCM OBTENIDO NATIVAMENTE:", fcm.token);
            clearTimeout(timeout);
            resolve(fcm.token);
          } catch (fcmErr) {
            console.error("❌ [LOG] Error obteniendo token FCM del SDK:", fcmErr.message);
            clearTimeout(timeout);
            resolve(null);
          }
        });

        PushNotifications.addListener('registrationError', (error) => {
          console.error("❌ [LOG] ERROR DE REGISTRO APNs:", error);
          clearTimeout(timeout);
          resolve(null);
        });

        PushNotifications.checkPermissions().then(res => {
          console.log("🔍 [LOG] Permisos actuales:", res.receive);
          if (res.receive !== 'granted') {
            PushNotifications.requestPermissions().then(result => {
              console.log("🔍 [LOG] Permisos tras solicitar:", result.receive);
              if (result.receive === 'granted') {
                try {
                  PushNotifications.register();
                } catch (regErr) {
                  console.error("❌ [LOG] Error llamando a register():", regErr.message);
                  clearTimeout(timeout);
                  resolve(null);
                }
              } else {
                console.warn("🚫 [LOG] Permisos denegados por el usuario.");
                clearTimeout(timeout);
                resolve(null);
              }
            }).catch(permErr => {
              console.error("❌ [LOG] Error solicitando permisos:", permErr.message);
              clearTimeout(timeout);
              resolve(null);
            });
          } else {
            try {
              PushNotifications.register();
            } catch (regErr) {
              console.error("❌ [LOG] Error llamando a register():", regErr.message);
              clearTimeout(timeout);
              resolve(null);
            }
          }
        }).catch(err => {
          console.error("❌ [LOG] Error en checkPermissions:", err.message);
          clearTimeout(timeout);
          resolve(null);
        });
      } catch (err) {
        console.error("❌ [LOG] Excepción en requestForToken:", err.message);
        resolve(null);
      }
    });
  }

  // --- VERSION WEB (Fallback) ---
  try {
    const permission = await Notification.requestPermission();
    if (permission === "granted") {
      const currentToken = await getToken(messaging, {
        vapidKey: "BIEGmSpWEOKkqQiPlKGCLHhcNwuqHoBKlefgF4XnX76Ki-lY-2tPK8WWit8xJp8wySlcL8pM_qO8cJyKUUo3EJU",
      });
      if (currentToken) {
        console.log("FCM Token Web:", currentToken);
        return currentToken;
      }
    }
  } catch (err) {
    console.log("An error occurred while retrieving web token. ", err);
  }
  return null;
};

// Variable global para capturar la acción de notificación al iniciar la app antes de que React monte los listeners
let pendingNotificationAction = null;

if (typeof window !== 'undefined' && Capacitor.isNativePlatform()) {
    try {
        PushNotifications.addListener('pushNotificationActionPerformed', (action) => {
            console.log("✈️ CAPACITOR GLOBAL ACTION PERFORMED:", action);
            const notification = action.notification;
            pendingNotificationAction = {
                notification: { title: notification.title, body: notification.body },
                data: notification.data
            };
            // Disparar un evento global por si el componente ya está montado
            const event = new CustomEvent('pending_push_action', { detail: pendingNotificationAction });
            window.dispatchEvent(event);
        });
    } catch (e) {
        console.error("❌ Error registrando listener global de push actions:", e);
    }
}

export const getPendingPushAction = () => {
    const action = pendingNotificationAction;
    pendingNotificationAction = null; // Consumir para evitar dobles ejecuciones
    return action;
};

export const onMessageListener = () =>
  new Promise((resolve) => {
    try {
      if (Capacitor.isNativePlatform()) {
          // Listener para primer plano
          PushNotifications.addListener('pushNotificationReceived', (notification) => {
              resolve({ 
                  notification: { title: notification.title, body: notification.body }, 
                  data: notification.data 
              });
          });
          
          // Escuchar también el evento personalizado si se dispara estando ya la app abierta
          const handleCustomAction = (e) => {
              window.removeEventListener('pending_push_action', handleCustomAction);
              resolve(e.detail);
          };
          window.addEventListener('pending_push_action', handleCustomAction);
      } else {
          onMessage(messaging, (payload) => {
              resolve(payload);
          });
      }
    } catch (err) {
      console.error("❌ Error en onMessageListener:", err);
      resolve(null);
    }
  });

export default app;